import React, { FC, useEffect, useRef } from 'react'

import { ArrowRightIcon, IconWeight } from '@inno-ui/icons'
import { useTranslation } from 'react-i18next'

import styles from './HelloScreen.module.scss'
import { CenteredStepContentProps } from './HelloScreen.types'
import clusterixLogo from '/public/clusterix-logo-white.svg'

export const HelloScreen: FC<CenteredStepContentProps> = ({
  onNext,
  onSkip
}) => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'desktop.full_page_onboarding.welcome_screen'
  })
  const startButtonRef = useRef<HTMLButtonElement>(null)

  useEffect(() => {
    startButtonRef.current?.focus()
  }, [])

  return (
    <section
      className={styles.helloScreen}
      role='dialog'
      aria-modal='true'
      aria-labelledby='full-page-onboarding-intro-title'
      aria-describedby='full-page-onboarding-intro-description'
    >
      <div className={styles.content}>
        <div className={styles.message}>
          <h1 id='full-page-onboarding-intro-title' className={styles.title}>
            {t('title')}
          </h1>
          <img src={clusterixLogo} alt='Clusterix' className={styles.logo} />
        </div>

        <p
          id='full-page-onboarding-intro-description'
          className={styles.description}
        >
          {t('description')}
        </p>
      </div>

      <div className={styles.actions}>
        <button
          ref={startButtonRef}
          type='button'
          className={styles.startButton}
          onClick={onNext}
        >
          <span>{t('start_button')}</span>
          <ArrowRightIcon weight={IconWeight.Bold} aria-hidden='true' />
        </button>
        <button type='button' className={styles.skipButton} onClick={onSkip}>
          {t('skip_button')}
        </button>
      </div>
    </section>
  )
}
